import { render, staticRenderFns } from "./ImportarImagensEmLote.vue?vue&type=template&id=1bc51aa4&scoped=true&"
import script from "./ImportarImagensEmLote.vue?vue&type=script&lang=js&"
export * from "./ImportarImagensEmLote.vue?vue&type=script&lang=js&"
import style0 from "./ImportarImagensEmLote.vue?vue&type=style&index=0&id=1bc51aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc51aa4",
  null
  
)

export default component.exports